// extracted by mini-css-extract-plugin
export default {"el":"RangeDatePicker_el__8f7s5"};